// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"343":"abd815ba","698":"c152778e","702":"a23f7f09"}[chunkId] + ".chunk.css";
};